import {
  EditFRDMeasurementConfigTask,
  FRDMeasurementConfigTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickFrdLibraryFields } from "../../../schema/frd-schema-library";

const sharedTitle = (type: FormType | undefined) => `FRD-Meetconfiguratie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het FRD Meetconfiguratie formulier. Gebruik het template om de meetconfiguraties door te geven. ${getDocsLinkMarkdown(
  "FRD"
)}`;

const getFrdMeasurementConfigCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<FRDMeasurementConfigTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "measurementConfigFile"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickFrdLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    ...pickFrdLibraryFields(["measurementConfigFile"]),
  },
});

const getFrdMeasurementConfigEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditFRDMeasurementConfigTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "measurementConfigFile"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickFrdLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickFrdLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    ...pickFrdLibraryFields(["measurementConfigFile"]),
  },
});

export function getFrdMeasurementConfigSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditFRDMeasurementConfigTask>;
export function getFrdMeasurementConfigSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<FRDMeasurementConfigTask>;
export function getFrdMeasurementConfigSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditFRDMeasurementConfigTask> | SchemaForFormData<FRDMeasurementConfigTask>;
export function getFrdMeasurementConfigSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getFrdMeasurementConfigEditSchema(type)
    : getFrdMeasurementConfigCreateSchema(type);
}
